import { Skeleton } from '@/components/ui/skeleton';

export function AccountsRowSkeleton() {
  return (
    <div
      className="grid min-h-28 grid-cols-[minmax(0,1fr)_44px] items-center gap-3 px-4 py-4 md:min-h-[68px] md:grid-cols-[minmax(0,1fr)_120px_130px_44px] md:py-3"
      aria-hidden="true"
    >
      <div className="flex min-w-0 items-center gap-3">
        <Skeleton className="size-10 shrink-0 rounded-full" />
        <div className="flex min-w-0 flex-1 flex-col gap-2">
          <Skeleton className="h-3.5 w-full max-w-48" />
          <Skeleton className="h-2.5 w-28 max-w-full" />
        </div>
      </div>
      <Skeleton className="col-start-1 h-6 w-20 rounded-full md:col-start-auto" />
      <Skeleton className="hidden h-3 w-24 md:block" />
      <Skeleton className="col-start-2 row-start-1 size-9 justify-self-end rounded-lg md:col-start-auto md:row-start-auto" />
    </div>
  );
}
